cb.define([], function() {
  const enablestatus = "false";
  const disablestatus = "true";
  var AA_aa_areaclass_VM_extend = {

    doAction: function(name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function(viewmodel) {
      var self = this;
      /*viewmodel.on('beforeClose', function () {
	  	  self.beforeClose(viewmodel);
	 	 });
	 	 viewmodel.on('afterClose', function () {
	 	   self.afterClose(viewmodel);
		  });
		  viewmodel.on("beforeOpen", function () {
		    return self.beforeOpen(viewmodel);
		  });
		  viewmodel.on("afterOpen", function () {
	 	   self.afterOpen(viewmodel);
	 	});*/
      viewmodel.on("beforeDelete", function() {
        return self.beforeDelete(viewmodel);
      });
      viewmodel.on("beforeSave", function() {
        var stopstatus = viewmodel.get("stopstatus").getValue();
        let status = self.beforeSave(viewmodel);
        if (status && (stopstatus === true || stopstatus === disablestatus)) {
          var returnPromise = new cb.promise();
          cb.utils.confirm('您确定停用当前地区和所有下级地区？', function() {
            return returnPromise.resolve();
          }, function() {
            returnPromise.reject();
          });
          return returnPromise;
        } else {
          return status;
        }
      });
      viewmodel.on("afterSave", function(data) {
        self.afterSave(viewmodel, data);
      });
      //选择上级地区之前，判断，选定的地区是否已经是当前地区的下级地区
      viewmodel.get("parent_name").on("beforeValueChange", function(data) {
        let currentAreaId = viewmodel.get("id").getValue();
        /*if (!data.value || data.value.length == 0) // 地区参照未选中任何地区节点
          return false;*/
        if (!currentAreaId) { // 当前地区节点没有上级地区，说明是新增的地区节点
          return true;
        }
        var selectedAreas = viewmodel.getTreeModel().getSelectedNodes();
        return self.canChoose(data.value, selectedAreas[0]);
      });

      /*      viewmodel.on("afterLoadData", function (data) {
              //未选中任何树节点
              if (viewmodel.getParams().mode === 'add') {
                viewmodel.get("btnDelete").setDisabled(true);
              } else if (data.stopstatus) {     //选中节点，且该节点已启用
                self.setEditable(viewmodel);
              } else {
                self.setUnEditable(viewmodel);  //选中节点，且该节点未启用
              }
            });*/

      /*      viewmodel.get('stopstatus').on('afterValueChange', function (args) {
               // var openUrl = "/membercenter/bill/unstop.do";
               // var closeUrl = "/membercenter/bill/stop.do";
               // args.value ? viewmodel.biz.do('open', viewmodel,openUrl) : viewmodel.biz.do('close', viewmodel,closeUrl);
              !args.value ? viewmodel.biz.do('close', viewmodel) : viewmodel.biz.do('open', viewmodel);
	
            });*/

      viewmodel.get("aa_areaclass").on("afterSelect", function(data) {
        viewmodel.get("code").setDisabled(false);
        viewmodel.get("name").setDisabled(false);
        viewmodel.get("parent_name").setDisabled(false);
        viewmodel.get("stopstatus").setDisabled(false);
        if (data[0] && !data[0].stopstatus) { //地区停用了，新增按钮不可以点击
          if (viewmodel.get("btnAdd"))
            viewmodel.get("btnAdd").setDisabled(false);
        } else {
          if (viewmodel.get("btnAdd"))
            viewmodel.get("btnAdd").setDisabled(true);
        }
      });
      viewmodel.on("modeChange", function(data) {
        if (data == "add") {
          //新增状态:新增按钮+删除按钮不可编辑
          if (viewmodel.get("btnAdd"))
            viewmodel.get("btnAdd").setDisabled(true);
          if (viewmodel.get("btnDelete"))
            viewmodel.get("btnDelete").setDisabled(true);
        } else {
          if (viewmodel.get("btnAdd"))
            viewmodel.get("btnAdd").setDisabled(false);
          if (viewmodel.get("btnDelete"))
            viewmodel.get("btnDelete").setDisabled(false);
        }
      });
    },
    canChoose: function(value, areas) {
      if (value.id === areas.id) {
        cb.utils.alert('只能选择上级地区！', 'warning');
        return false;
      }
      if (areas.children) {
        for (var i = 0, len = areas.children.length; i < len; i++) {
          if (this.canChoose(value, areas.children[i])) continue;
          return false;
        }
      }
      return true;
    },
    beforeClose: function(viewmodel) {},
    beforeDelete: function(viewmodel) {
      /*var selectedNode = viewmodel.get("aa_areaclass").getSelectedNodes()[0];
      if(selectedNode.level === 0){
        cb.utils.alert("根节点不允许删除！");
        return false;
      }*/
    },
    beforeSave: function(viewmodel) {
      /*var selectedNode = viewmodel.get("aa_areaclass").getSelectedNodes()[0];
      var parent = viewmodel.get("parent").getValue();
      if((typeof (selectedNode) == "undefined" ||
        selectedNode.level !== 1) && parent == null){
        cb.utils.alert("上级地区不允许为空！",'warning');
        return false;
      }
*/
      let stopstatus = viewmodel.get("stopstatus").getValue();
      if (!stopstatus || stopstatus == enablestatus) {
        // 检查 当前地区是否允许启用
        if (!this.checkCanOpen(viewmodel)) {
          return false;
        }
      }
      return true;
    },
    afterSave: function(viewmodel, data) {
      if (data.err != undefined) {
        //cb.utils.alert(data.err.message,"error");
        return false;
      }
      viewmodel.get("pubts").setValue(data.res.pubts);
      let stopstatus = data.res.stopstatus;
      if (stopstatus || stopstatus == disablestatus) {
        //停用父节点，子节点全部都需要停用
        var selectedArea = viewmodel.getTreeModel().getSelectedNodes();
        var treeModel = viewmodel.getTreeModel();
        treeModel.updateNodeRecursive(selectedArea[0], "stopstatus", true);
        // 新增按钮置灰
        viewmodel.get("btnAdd").setDisabled(true);
      } else {
        viewmodel.get("btnAdd").setDisabled(false);
      }
    },

    /* afterClose: function (viewmodel) {
      this.setUnEditable(viewmodel);
      //停用父节点，子节点全部都需要停用
      var selectedArea = viewmodel.getTreeModel().getSelectedNodes();
      var treeModel = viewmodel.getTreeModel();
      treeModel.updateNodeRecursive(selectedArea[0], "stopstatus", false);
    },
    
    beforeOpen: function (viewmodel) {
			//若上级地区已经停用，则该地区不允许启用
      let treeModel = viewmodel.getTreeModel();
      let parent = viewmodel.get("parent").getValue();
      let parentNode = treeModel.getNodesByKeys([parent])[0];
      if(!parentNode.stopstatus){
        cb.utils.alert("上级地区已停用，无法启用当前地区！","error");
        viewmodel.get("stopstatus").setValue(false);
        return false;
      }
    },
    afterOpen: function (viewmodel) {
      //viewmodel.get("isEnable").setValue(true);
      this.setEditable(viewmodel);
    },*/
    //保存前，校验是否允许启用
    checkCanOpen: function(viewmodel) {
      //若上级地区已经停用，则该组织不允许启用
      let treeModel = viewmodel.getTreeModel();
      let parent = viewmodel.get("parent").getValue();
      if (parent) {
        let parentNode = treeModel.getNodesByKeys([parent])[0];
        if (parentNode.stopstatus || parentNode.stopstatus == disablestatus) {
          cb.utils.alert("上级地区已停用，无法启用当前地区！", "error");
          viewmodel.get("stopstatus").setValue(disablestatus);
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    setUnEditable: function(viewmodel) {
      //设置整个viewmodel不可编辑
      viewmodel.setReadOnly(true);
      viewmodel.get("btnAdd").setDisabled(true);
      viewmodel.get("stopstatus").setReadOnly(false);
      //viewmodel.get("btnSave").setVisible(true);
      //viewmodel.get("btnAbandon").setVisible(true);
      viewmodel.get("btnDelete").setDisabled(false);
    },
    setEditable: function(viewmodel) {
      viewmodel.setReadOnly(false);
      viewmodel.get("btnAdd").setDisabled(false);
      viewmodel.get("stopstatus").setReadOnly(false);
      //viewmodel.get("btnSave").setVisible(true);
      //viewmodel.get("btnAbandon").setVisible(true);
      viewmodel.get("btnDelete").setDisabled(false);
    },
  }
  try {
    module.exports = AA_aa_areaclass_VM_extend;
  } catch (error) {

  }
  return AA_aa_areaclass_VM_extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_areaclass_VM.Extend.js